import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authAPI } from "../api/api";
import { Button, Input, Alert } from "../components/UI";
import { Mail, Leaf } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { setError("Please enter your email address"); return; }
    setLoading(true);
    setError("");
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError("Could not send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 via-white to-earth-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md animate-slide-up">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-600 text-white rounded-2xl shadow-lg mb-4">
            <Leaf size={32} />
          </div>
          <h1 className="text-3xl font-900 text-brand-800">Reset Password</h1>
          <p className="text-brand-500 font-600 mt-1">We'll send you a reset link</p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-brand-100 p-6 lg:p-8">
          {sent ? (
            <div className="text-center py-4">
              <div className="text-6xl mb-4">📬</div>
              <h3 className="text-xl font-800 text-brand-800 mb-2">Check Your Email!</h3>
              <p className="text-brand-500 font-600">We sent a password reset link to <strong>{email}</strong></p>
              <Link to="/login" className="mt-6 inline-block">
                <Button variant="secondary">← Back to Sign In</Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              {error && <Alert type="error" onDismiss={() => setError("")}>{error}</Alert>}
              <Input label="📧 Your Email Address" type="email" placeholder="yourname@email.com" value={email} onChange={(e) => setEmail(e.target.value)} icon={Mail} />
              <Button type="submit" size="lg" loading={loading} className="w-full mt-2">
                📨 Send Reset Link
              </Button>
            </form>
          )}
        </div>

        {!sent && (
          <p className="text-center mt-6 text-brand-600 font-700">
            Remembered it?{" "}
            <Link to="/login" className="text-brand-700 underline font-800">Sign In</Link>
          </p>
        )}
      </div>
    </div>
  );
}
